import R from 'ramda';
import Url from 'url';

export const splitPath = path =>
  R.isNil(path) || R.isEmpty(path) ? [] : R.filter(R.identity, path.split('/'));

export const parsePathname = R.pipe(Url.parse, R.path(['pathname']));

export const parsePaths = R.pipe(parsePathname, splitPath);

export const isValidRoute = url => {
  const paths = parsePaths(url);
  return paths.length >= 0 && paths.length <= 2;
};

export const parseProjectKey = url => {
  const paths = parsePaths(url);
  return paths.length === 2 ? paths[0] : void 0;
};

export const parseOrganizationAlias = url => R.last(parsePaths(url));



// WEBPACK FOOTER //
// ./src/common/urlHelpers.js